export default __webpack_public_path__ + "static/media/CerrarCaja.ba72e58b.png";